import script from "./StudentsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentsView.vue?vue&type=script&setup=true&lang=ts"

import "./StudentsView.vue?vue&type=style&index=0&id=a365f3f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a365f3f4"]])

export default __exports__